module.exports = __webpack_public_path__ + "img/get-ready-bg-right.c8105bc4.png";